import React from 'react';
import { Modal, Message, Button } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';

export default function ConfirmModal({ show, onSubmit, onClose, isSubmitting, subscriptionLinks }) {
    const { t } = useTranslation();

    return (
        <Modal
            size="large"
            open={show}
            onClose={onClose}
            title={t('ticket.webservice.subscription-link.confirm-modal.subtitle')}
            submitButton={
                <Button primary onClick={onSubmit} disabled={isSubmitting}>
                    {t('ticket.common.cta.confirm')}
                </Button>
            }
            cancelButton={<Button onClick={onClose}>{t('ticket.common.cta.cancel')}</Button>}
        >
            {subscriptionLinks.length > 0 && (
                <div>
                    <Message type="warning" title={t('ticket.webservice.mapping.confirm-modal.message.title')}>
                        {t('ticket.webservice.mapping.confirm-modal.message.info')}
                    </Message>
                </div>
            )}
        </Modal>
    );
}
